@if (httpError == '404') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.stock-reorder.shared.errors.not-found' | translate }}
	</mat-error>
}
@if (httpError == '500') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.stock-reorder.shared.errors.internal-server-error' | translate }}
	</mat-error>
}

<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.stock-reorder.delete-stock-reorder.title' | translate }}
</h1>
<div mat-dialog-content>
	<p>{{ 'mes.stock-reorder.delete-stock-reorder.content' | translate }}</p>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'general.ok' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
</div>
